<template>
  <BForm v-if="isLoaded" novalidate>
    <FormWrapper v-if="canCreate && !isSent" :validator="$v.form">
      <!-- <BaseCertificationFormStepHeader :v="$v" /> -->
      <BaseCertificationFormSteps :v="$v" :form="form" />

      <Section
        v-if="history && history[0] && history[0].staffComments"
        title="Uwagi CO do formularza"
      >
        <CertificationFormGroup name="staffComments"> </CertificationFormGroup>
      </Section>

      <div class="row">
        <div
          :class="{
            'col-lg-8': showSummary,
            'col-lg-12': !showSummary
          }"
        >
          <CertificationFormStep1
            v-show="currentStep == 1"
            v-model="form"
            :v="$v"
          />

          <CertificationFormStep2
            v-show="currentStep == 2"
            v-model="form"
            :v="$v"
          />
          <CertificationFormStep3
            v-show="currentStep == 3"
            v-model="form"
            :v="$v"
          />
          <CertificationFormStep4
            v-show="currentStep == 4"
            v-model="form"
            :v="$v"
          />
          <CertificationFormStep5
            v-show="currentStep == 5"
            v-model="form"
            :v="$v"
          />
          <CertificationFormStep6
            v-show="currentStep == 6"
            v-model="form"
            :v="$v"
          />
          <CertificationFormStep7
            v-show="currentStep == 7"
            v-model="form"
            :v="$v"
          />
          <CertificationFormStep8
            v-show="currentStep == 8"
            v-model="form"
            :v="$v"
          />

          <CertificationFormStep9
            v-show="currentStep == 9"
            v-model="form"
            :v="$v"
          />
        </div>
        <div v-if="showSummary" class="col-lg-4">
          <BaseAdminCertificationSummary v-if="isAdmin" />
          <BaseUserCertificationSummary v-if="isUser" />
        </div>
      </div>

      <hr />

      <BaseAdminCertificationEvaluation
        v-if="isAdmin && !moderationDisabled"
        @input="form.newStatus = $event"
      />

      <!-- <BaseCertificationError
        v-if="isError"
        :message="errorMessage"
        :error="responseData"
      /> -->

      <BaseCertificationFormStepFooter
        :v="$v"
        :is-sending="isSending"
        :is-sent="isSent"
        v-model="form"
        @form:submit="submit()"
        @form:draft="draft()"
      />
    </FormWrapper>

    <template v-if="!hasActiveOrganization && !isAdmin">
      <div class="text-center">
        <Alert show variant="danger">
          Nie możesz zgłosić wydarzenia, ponieważ nie należysz do żadnej
          organizacji<br />lub żadna z Twoich organizacji nie została jeszcze
          zatwierdzona przez CO
        </Alert>
        <btn :to="`/user/account`" variant="outline-primary" icon="user"
          >Przejdź do profilu</btn
        >
      </div>
    </template>

    <BaseCertificationThanks v-if="isSent" :form="form" />
  </BForm>
</template>

<script>
import BaseCertificationThanks from "@/components/Base/Certification/BaseCertificationThanks";
// import BaseCertificationError from "@/components/Base/Certification/BaseCertificationError";
import BaseCertificationForm from "@/components/Base/Certification/BaseCertificationForm";
import BaseAdminCertificationEvaluation from "@/components/Base/Certification/BaseAdminCertificationEvaluation";

import CertificationFormSteps from "./CertificationFormSteps";
import validations from "./validation/";
import steps from "./steps";

import { testData } from "./testData";
import ModelFactory from "@/model/ModelFactory";

const transformObjectKeys = require("transform-object-keys");

export default {
  name: "CertificationForm191001",

  validations,
  components: {
    ...CertificationFormSteps,
    BaseCertificationThanks,
    // BaseCertificationError,
    BaseAdminCertificationEvaluation
  },
  extends: BaseCertificationForm,
  data() {
    return {
      version: "191001",
      steps,
      stepComponentPrefix: "CertificationFormStep"
    };
  },
  created() {
    setTimeout(() => {
      if (Object.getOwnPropertyNames(testData).length > 0) {
        let convertedTestData = transformObjectKeys(testData, {
          deep: true,
          transform: key =>
            key.replace(/_([a-z])/, function(t) {
              return t.replace("_", "").toUpperCase();
            })
        });
        convertedTestData = ModelFactory.create(
          "EventModel",
          convertedTestData
        );

        this.$set(this, "form", convertedTestData);
        this.$store.dispatch("Form/enableAllSteps");
      }
    }, 1000);
  },
  mounted() {
    if (this.user.isAdmin()) {
      this.skipValidation = true;
    }
  }
};
</script>

<style>
.vjs-tree {
  font-size: 11px;
}
.vjs-key {
  width: 120px;
  display: inline-block;
}
</style>
